exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_2HTaD {\n    padding: 0 80px;\n}\n\n.infoContainer_2HTaD > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.referalContainer_3lMfz {\n    padding-top: 30px;\n}\n\n.sectionSubList_3i5GZ {\n    list-style: none;\n    position: relative;\n}\n\n.sectionListChild_18VHQ {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.sectionListChild_18VHQ input {\n    position: absolute;\n    left: 10px;\n    line-height: 20px;\n}\n\n.submitContent_1bZP9 {\n    padding-top: 10px;\n    font-weight: 800;\n    font-style: italic;\n}\n\n.gapSection17_13sIr {\n    height: 20px;\n}\n\n.signatureSize_2kqup img {\n    max-width: 200px;\n    max-height: 80px;\n}", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_2HTaD",
	"referalContainer": "referalContainer_3lMfz",
	"sectionSubList": "sectionSubList_3i5GZ",
	"sectionListChild": "sectionListChild_18VHQ",
	"submitContent": "submitContent_1bZP9",
	"gapSection17": "gapSection17_13sIr",
	"signatureSize": "signatureSize_2kqup"
};